import type { ComponentProps } from "react";

import type { ArtSectionType } from "@features/home-art-sections/model";
import { MediaCard } from "@features/media-card/ui";

import type { ColorIconType } from "@shared/content-types/types";
import { BrandIcon } from "@shared/ui/brand-icon";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Image } from "@shared/ui/image";
import { Heading } from "@shared/ui/typography";
import { getMediaType } from "@shared/utils/get-media-type";

import s from "./second-type.module.scss";

export type SecondTypeProps = ComponentProps<"div"> & {
  data: ArtSectionType;
  pageIcon: ColorIconType;
};

export const SecondType = (props: SecondTypeProps) => {
  const {
    data: {
      title,
      buttonText,
      buttonLink,
      mainImage,
      media_post,
      icon,
      bigIcon,
    },
    pageIcon,
  } = props;

  return (
    <div className={s.root}>
      <div className={s.wrapper}>
        <div className={s.info}>
          {icon?.icon?.name && (
            <BrandIcon
              name={icon.icon.name}
              fillColor={icon.fillColor ?? "gold"}
              strokeColor={icon.strokeColor ?? "bistre"}
              className={s.infoIcon}
            />
          )}
          {title && (
            <Heading level={6} tag="h3" className={s.title}>
              {title}
            </Heading>
          )}
          {buttonLink && buttonText && (
            <ButtonWithIcon
              href={buttonLink}
              variant="primary-dark"
              iconFillColor={pageIcon?.fillColor}
              iconStrokeColor={pageIcon?.strokeColor}
              iconName={pageIcon?.icon?.name ?? "plus"}
              iconSvgCode={pageIcon?.uicon?.svg_code}
              className={s.button}
            >
              {buttonText}
            </ButtonWithIcon>
          )}
        </div>
      </div>
      {mainImage?.url && (
        <Image
          src={mainImage.url}
          alt={mainImage?.alternativeText ?? "art image"}
          height="100%"
          className={s.mainImage}
        />
      )}
      <div className={s.images}>
        {bigIcon?.icon?.name && (
          <BrandIcon
            name={bigIcon.icon.name}
            fillColor={bigIcon.fillColor ?? "gold"}
            strokeColor={bigIcon.strokeColor ?? "bistre"}
            className={s.icon}
          />
        )}
        {media_post && (
          <MediaCard
            post={media_post}
            isVideo={
              getMediaType(media_post?.mediaContent?.media?.mime!) === "video"
            }
          />
        )}
      </div>
    </div>
  );
};

SecondType.displayName = "SecondType";
